import React from 'react'

import {noop} from 'es-toolkit'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import chevronDownIcon from '../../../../commons/src/assets/icons/chevron-down.svg'

import {OrderStatusOption} from '../../containers/order/order-status-partial'

import Icon from '../../../../commons/src/components/icon'
import PopoverHandler from '../../../../commons/src/components/popover-handler'
import SelectMenu from '../../../../commons/src/components/select-menu'

import {OrderStatusType} from '../../order-types'
import OrderStatusBadge from '../order-status-badge/OrderStatusBadge'

type Props = Overwrite<
  CommonProps<'button'>,
  {
    menu: React.ReactElement<React.ComponentProps<typeof SelectMenu>>
    value: OrderStatusType
    name?: string
    disabled?: boolean
    size?: '90' | '100'
    onChange: (value: OrderStatusOption, name: string | undefined) => void
    onBlur?: React.FocusEventHandler
  }
>

const OrderStatusSelectField = ({
  className,
  menu,
  value,
  name,
  disabled = false,
  size = '100',
  onChange,
  onBlur = noop,
  ...props
}: Props) => {
  return (
    <PopoverHandler
      popover={({close, ref, style, anchorRect}) => (
        <div
          ref={ref}
          className="OrderStatusSelectField__menu"
          style={{
            ...style,
            minWidth: anchorRect?.width,
          }}
        >
          {React.cloneElement(menu, {
            onClick: item => {
              onChange(item as OrderStatusOption, name)
              close()
            },
            selectedValue: value as unknown as OrderStatusOption,
          })}
        </div>
      )}
    >
      {({isOpen, toggle, ref}) => (
        <button
          {...props}
          ref={ref}
          type="button"
          name={name}
          className={cn(
            'OrderStatusSelectField',
            {
              selected: !!value,
              open: isOpen,
              [`size-${size}`]: !!size,
              disabled,
            },
            className
          )}
          onBlur={event => {
            event.target.value = `${value}`
            event.target.name = `${name}`
            onBlur(event)
          }}
          onClick={toggle}
          disabled={disabled}
        >
          <span className="OrderStatusSelectField__value">
            {value && <OrderStatusBadge type={value} size={size === '90' ? 'xs' : 's'} />}
          </span>
          <span className="OrderStatusSelectField__icon">
            <Icon source={chevronDownIcon} />
          </span>
        </button>
      )}
    </PopoverHandler>
  )
}

export default OrderStatusSelectField
